import React from 'react';
import styled, { keyframes } from "styled-components";

const slideFromRight = keyframes`
  from {
    transform: translateX(120px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const PresentationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  padding: 0 20px;

  animation: ${slideFromRight} 1.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;

  @media (max-width: 375px) {
    align-items: center;
    text-align: center;
    padding: 0 12px;
  }
`;

const RoleText = styled.h1`
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: clamp(18px, 4.8vw, 25px);
  color: #666666;
  margin-top: 20px;
  margin-right: 80px;

  @media (max-width: 600px) {
    margin-right: 24px;
  }

  @media (max-width: 375px) {
    font-size: 18px;
    margin-top: 40px;
    margin-right: 0;
  }

  @media (max-width: 320px) {
    font-size: 16px;
    margin-top: 32px;
  }
`;

function PresentationR() {
  return (
    <PresentationContainer>
      <RoleText>
        Web Developer based in Sweden
      </RoleText>
    </PresentationContainer>
  );
}

export default PresentationR;